const CommitmentSection = () => {
  const commitments = [
    "Bảo hành chính hãng đầy đủ.",
    "Hỗ trợ khách hàng nhanh chóng, tận tình.",
    "Giao hàng nhanh, an toàn và chính xác.",
    "Đổi trả linh hoạt trong 30 ngày.",
  ];

  return (
    <section className="w-full bg-white py-16 px-6 lg:px-16">
      <div className="max-w-7xl mx-auto text-center space-y-8">
        <h2 className="text-2xl lg:text-4xl font-bold text-gray-800">
          Cam Kết Của Chúng Tôi
        </h2>
        <ul className="list-none space-y-4 text-lg text-gray-600">
          {commitments.map((item, index) => (
            <li
              key={index}
              className="flex items-center justify-center space-x-2"
            >
              <span className="text-green-500">✔</span>
              <p>{item}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default CommitmentSection;
